import {
  createDirectus,
  rest,
  aggregate,
  authentication,
  readItems,
  createItem,
  updateItem,
  deleteItem,
  readItem,
} from "@directus/sdk";

const client = createDirectus(location.origin)
  .with(authentication("cookie"))
  .with(rest());

async function get(id, limit, offset, filter, search, sort, fields) {
  let obj = {
    filter: {},
    fields: ["*,users.*,server_id.*"],
  };
  if (fields) obj.fields = fields;
  if (limit != null) obj.limit = limit;
  if (offset != null) obj.offset = offset;
  if (sort != null) obj.sort = sort;
  if (id != null)
    obj.filter = {
      users: {
        _some: { directus_users_id: { _eq: id } },
      },
    };

  if (filter && Object.keys(filter).length !== 0) {
    obj.filter = { ...obj.filter, ...filter };
  }
  if (search && search.length > 0) obj.search = search;
  const totalCount = await client.request(
    aggregate("mailboxes", {
      aggregate: { count: "*" },
      query: { filter: { ...obj.filter } },
    })
  );
  const data = await client.request(readItems("mailboxes", obj));
  return { totalCount: totalCount[0].count, data };
}
async function getById(id) {
  return await client.request(
    readItem("mailboxes", id, {
      fields: ["*,users.*,users.directus_users_id.*"],
    })
  );
}
async function create(data) {
  return await client.request(
    createItem("mailboxes", data, {
      fields: ["*,users.*,users.directus_users_id.*"],
    })
  );
}

async function updateById(id, data) {
  return await client.request(
    updateItem("mailboxes", id, data, {
      fields: ["*,users.*,users.directus_users_id.*"],
    })
  );
}

async function deleteById(id) {
  return await client.request(deleteItem("mailboxes", id));
}
export default {
  get,
  create,
  deleteById,
  getById,
  updateById,
};
